"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/ParticipantsPicker/ResultsList/ResultsSection/EntityItem.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _Avatar = require('web/components/Avatar');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);







const EntityItem = ({ entity, onSelectEntity, isDisabled = false }) => (
  _react2.default.createElement('div', {
    role: "button",
    'aria-disabled': isDisabled || undefined,
    tabIndex: isDisabled ? -1 : undefined,
    className: _classBuilder2.default.call(void 0, 
      "participants-picker--result",
      isDisabled && "participants-picker--result--disabled",
    ),
    onClick: isDisabled ? undefined : () => onSelectEntity(entity), __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}

    , _react2.default.createElement('div', { className: "participants-picker--result--avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
      , _react2.default.createElement(_Avatar.EntityAvatar, { size: 40, entity: entity, __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}} )
    )
    , _react2.default.createElement('div', { className: "participants-picker--result--info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
      , _react2.default.createElement('span', { className: "participants-picker--result--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
        ,  entity.name 
      )
      , _react2.default.createElement('span', { className: "participants-picker--result--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
        ,  entity.description 
      )
    )
  )
)

exports. default = EntityItem
